<template>
  <div class="hj-footer">
    <el-row class="mb10">
      <h2>友情链接</h2>
      <div class="footer-menu-list">
        <div class="footer-menu" @click="handleSelect('aboutUs')">关于我们</div>
        <div class="footer-menu" @click="handleSelect('companyDevelopt')">公司荣耀</div>
        <div class="footer-menu" @click="handleSelect('productIntroduction')">产品介绍</div>
        <div class="footer-menu" @click="handleSelect('usinessPartner')">合作伙伴</div>
        <div class="footer-menu" @click="handleSelect('joinUs')">联系我们</div>
      </div>
    </el-row>
    <el-row class="mb10">
      <h2>联系我们</h2>
      <div>
        <div class="contact-us-row">电话：021-50112219</div>
        <div class="contact-us-row">邮箱：service@insuresmart.com.cn</div>
        <div class="contact-us-row">总部地址：上海市浦东新区金海路1000号26号楼12层</div>
        <div class="contact-us-row">分部： <span class="pl20">合肥 </span><span class="pl20">西安</span></div>

        <!--          <div class="contact-us-row">西安分公司地址：西安市雁塔区科技二路65号K座703室</div>
                    <div class="contact-us-row">宁波分公司地址：宁波市鄞州区翔云北路99号9号楼5-1-6</div>-->
      </div>
    </el-row>
    <el-row class="mb10">
      <h2>荣誉资质</h2>
      <div>
        <div class="contact-us-row mb10">
          <div>Copyright©2025 因朔桔（上海）智能科技有限公司</div>
          <div>All rights reserved.</div>
        </div>
        <div class="contact-us-row mb10">
          <div>营业执照：</div>
          <div>统一社会信用代码 91310110MA1G8T1D9U</div>
        </div>
        <div class="contact-us-row mb10">
          <div>医疗机构执业许可证：</div>
          <div>登记号 MAE94FHU751011619A1002</div>
        </div>
        <div class="contact-us-row mb10">
          <div>互联网药品信息服务资格证书：</div>
          <div>（沪）-经营性-2022-0147</div>
        </div>
        <div class="contact-us-row mb10">
          <div>因朔桔旗下全资互联网医院：</div>
          <div>成都双流因朔桔互联网医院</div>
        </div>
        <div class="contact-us-row mb10">
          <div>互联网医院三级等保证书编号：</div>
          <div>51010045548-25001</div>
        </div>
      </div>
    </el-row>
    <el-row>
      <div style="width: 100%; display: flex; align-items: center">
        <div style="width: 50%; padding: 3%; display: flex; align-items: center">
          <img src="../../assets/img/home/logo-footer.png" width="90%" />
        </div>
        <div style="width: 50%; padding: 3%; display: flex; flex-direction: column; align-items: center">
          <img src="../../assets/img/home/ysj.jpg" height="80" />
          <div style="line-height: 40px">官方公众号</div>
        </div>
      </div>
    </el-row>
    <div style="margin:0 auto; padding:20px 0 0;text-align: center">
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">ICP备案许可证号 沪ICP备18034148号-9</p></a>
    </div>
    <div style="margin:0 auto; padding:20px 0 0;text-align: center">
      <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=31011502403366" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/img/home/gongan.png" style="width: 16px; height: 16px;float: left" /><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31011502403366号</p></a>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
  methods: {
    handleSelect(key) {
      debugger
      console.log(key, this.$route.path)
      const basePath = 'mobile'
      switch (key) {
        case 'companyDevelopt':
        case 'productIntroduction':
          if (this.$route.path == `/${basePath}/companyDevelopt`) {
            this.$emit('goAnchor', key)
          } else {
            this.$router.push({ path: `/${basePath}/companyDevelopt?key=${key}` })
            this.$emit('goAnchor', key)
          }
          break
        default:
          if (this.$route.path == `/${basePath}/index`) {
            this.$emit('goAnchor', key)
          } else {
            this.$router.push({ path: `/${basePath}/index?key=${key}` })
            this.$emit('goAnchor', key)
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hj-footer {
  padding: 20px;
  background-color: #333333;
  color: #ffffff;
  text-align: left;
  font-size: 14px;

  h2 {
    line-height: 50px;
    font-size: 18px;
    font-weight: 700;
  }

  .footer-menu-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .footer-menu {
    line-height: 30px;
    cursor: pointer;
  }

  .text-right {
    text-align: right;
  }

  .contact-us-row {
    line-height: 25px;
  }
}
</style>
